// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"32eb7b16","403":"7745c56b","455":"1b991356","626":"c15f163b","629":"3c99ad5f","977":"459ae33c"}[chunkId] + ".chunk.js";
};